import {AssistantEvenCompactModel} from "../assistants";
import {ListModel} from "../common";

import {EditRealTimeBookingSchemaFormData} from "@/utils/realTimeBooking/schema";
import {BaseAction} from "@/types/api";
import {ActionNodeData} from "@/types/node";

export enum RealTimeGHLActionStatusModel {
  new = "new",
  confirmed = "confirmed",
}

export enum RealTimeCalComActionTypeModel {
  calcom = "calcom",
}

export enum RealTimeGHLActionTypeModel {
  ghl = "ghl",
}

export interface RealTimeGHLActionModel {
  type: RealTimeGHLActionTypeModel;
  identifier?: string;
  prompt?: string | null;
  leadTimezone?: string;
  firstAppDate?: string;
  days?: number;
  slotsPerDay?: number;
  minHoursDiff?: number;
  calendarId?: string;
  locationId?: string;
  contactId?: string;
  title?: string;
  status?: RealTimeGHLActionStatusModel;
  assignedUserId?: string;
  address?: string;
  notify?: boolean;
  llmMessage?: string | null;
  getAvailabilityUrl?: string | null;
  createBookingUrl?: string | null;
}

export interface RealTimeCalComActionModel {
  type: RealTimeCalComActionTypeModel;
  leadTimezone?: string;
  firstAppDate?: string;
  days?: number;
  slotsPerDay?: number;
  minHoursDiff?: number;
  bookingEmail?: string;
  eventTypeId?: string;
  sendConfirmationSms?: boolean;
  confirmationSms?: string;
  calendarIntegration?: string;
}

export type RealTimeBookingActionConfigModel =
  | RealTimeCalComActionModel
  | RealTimeGHLActionModel;

export enum RealTimeBookingTypeModel {
  calcom = "calcom",
  ghl = "ghl",
}

export interface RealTimeBookingRecordModel extends BaseAction {
  type: RealTimeBookingTypeModel;
  title?: string | null;
  icon?: string | null;
  description?: string | null;
  workspaceId: string;
  assistants: AssistantEvenCompactModel[];
  config?: RealTimeBookingActionConfigModel;
  nodeData?: any;
}

export type RealTimeBookingListModel = ListModel<RealTimeBookingRecordModel>;

export interface RealTimeBookingCalComCreateModel
  extends EditRealTimeBookingSchemaFormData {
  eventId: string;
}
export interface RealTimeBookingGHLCreateModel {
  eventId?: string;
  calendarId?: string;
  timezone?: string;
  identifier?: string;
  firstAppDate?: string;
  days?: number;
  slotsPerDay?: number;
  minHoursDiff?: number;
  title?: string;
  status?: RealTimeGHLActionStatusModel;
  notify?: boolean;
  locationId?: string;
  contactId?: string;
  assignedUserId?: string;
  address?: string;
  prompt?: string | null;
  llmMessage?: string | null;
  getAvailabilityUrl?: string | null;
  createBookingUrl?: string | null;
}

export interface RealTimeBookingCreateModel {
  workspaceId: string;
  name: string;
  type: RealTimeCalComActionTypeModel | RealTimeGHLActionTypeModel;
  config: RealTimeBookingCalComCreateModel | RealTimeBookingGHLCreateModel;
}

export interface RealTimeBookingUpdateModel
  extends EditRealTimeBookingSchemaFormData {
  id: string;
  workspaceId: string;
  type: RealTimeCalComActionTypeModel | RealTimeGHLActionTypeModel;
}
